import React,{ useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import _, { round } from "lodash";

import { Dialog } from "primereact/dialog";
import Table  from "../../helpers/Table";
import Loading from "../../common/Loading";

import { getPayableAmount } from "../../services/api/vendorPayment";
import { raiseToast } from "../../services/redux/reducers/toast/toast";
import { fetchStates, fetchStatus } from "../../services/redux/reducers/commonThunk";
import { getCitySpentAmount, getPMBranches, refillWallet } from "../../services/api/pmBranch";

import { numberConversion } from "../../utils";
import { Button, TextInputField } from "../../helpers";
import { Tooltip } from "primereact/tooltip";
import { getCompanyBillAddrs } from "../../services/api/companyBillAddr";
import CreateInternalTransferInvoice from "./components/CreateInternalTransferInvoice";
import Menu from "../../helpers/Menu";
import { getPMCompanyConfig } from "../../setup/pmCompanyConfig";


const CashFlowTracker = () => {
    const [isLoading, setIsLoading] = useState(false)
    const [isWalletRefillVisible, setIsWalletRefillVisible] = useState(false)

    const [pmBranches, setPMBranches] = useState([])
    const [payableAmounts, setPayableAmounts] = useState([])
    const [spentAmounts, setSpentAmounts] = useState([])
    const [selectedBranch, setSelectedBranch] = useState([])
    const [amount, setAmount] = useState(0)
    const [pmBillAddresses, setPMBillAddresses] = useState([])
    const [warehouseShipAddresses, setWarehouseShipAddresses] = useState([])
    const [procmartStates, setProcmartStates] = useState([])
    const [isVisibleInternalTransferInv, setIsVisibleInternalTransferInv] = useState(false)

    const userDetails = useSelector(state => state.userDetails)
    const pmCompanyDetails = useSelector((state) => state.userDetails.PMCompanyDetails)
    const statesList = useSelector(state => state.common.states)
    const companyWarehouses = useSelector(state => state.common.companyWarehouses)

    const pmCompanyConfig = getPMCompanyConfig(userDetails.PMCompanyDetails.companyId)
    let { numberLocale } = pmCompanyConfig

    const dispatch = useDispatch()
    const actionMenu = useRef(null)
   
    useEffect(() => {
        dispatch(fetchStatus())
        dispatch(fetchStates())
        fetchPMBranches()
        fetchPayableAmount()
        //fetchCitySpentAmount()
    }, [])

    useEffect(() => {
        if(statesList?.length){
            getProcmartStates()
        }
    }, [statesList])

    const getProcmartStates = async () => {
        const procmartBillAddrIds =  _.map(pmCompanyDetails.companyBranches, 'primaryBillAddrId')
        const allPrimaryBillAddrIds = _.uniq(procmartBillAddrIds)

        const billAddrRes = await getCompanyBillAddrs({ billAddrIds: allPrimaryBillAddrIds, paginator: false })
        console.log("billAddrRes", billAddrRes)
        if (billAddrRes.failure) {
            setIsLoading(false)
            return dispatch(raiseToast({ severity: 'error', summary: 'billAddrRes', detail: billAddrRes.data.error, life: 3000 }))
        }
        setPMBillAddresses(billAddrRes?.data?.data)

        const companyWarehouseShipAddrsIds = pmCompanyDetails.companyWarehouses.map(eachWareHouse => eachWareHouse.shipAddrId)
        const shipAddresses = pmCompanyDetails.companyBranchShipAddrs.filter(eachAddr => companyWarehouseShipAddrsIds.includes(eachAddr.shipAddrId))
        setWarehouseShipAddresses(shipAddresses)

        const allStateIds = billAddrRes?.data?.data.map(eachBillAddr => eachBillAddr.stateId)
        const filteredStates = statesList?.filter(eachState => allStateIds.includes(eachState.stateId))
        console.log("statesList", statesList)
        setProcmartStates(filteredStates)
    }

    const fetchPMBranches = async () => {
        const pmBranchesResponse = await getPMBranches()

        if(pmBranchesResponse.failure){
            return dispatch(raiseToast({severity:'error', detail: pmBranchesResponse.data.error, life: 3000}))
        } else {
            console.log("pmBranchesResponse", pmBranchesResponse)
            setPMBranches(pmBranchesResponse.data)
        }
    }

    const fetchCitySpentAmount = async () => {
        const spentAmountResponse = await getCitySpentAmount()

        if(spentAmountResponse.failure){
            return dispatch(raiseToast({severity:'error', detail: spentAmountResponse.data.error, life: 3000}))
        } else {
            console.log("spentAmountResponse", spentAmountResponse)
            setSpentAmounts(spentAmountResponse.data)
        }
    }

    const fetchPayableAmount = async () => {
        const payableAmountResponse = await getPayableAmount()

        if(payableAmountResponse.failure){
            return dispatch(raiseToast({severity:'error', detail: payableAmountResponse.data.error, life: 3000}))
        } else {
            console.log("payableAmountResponse", payableAmountResponse)
            setPayableAmounts(payableAmountResponse.data)
        }
    }

    const getRefillWalletBody = (row) => {
        return(
            <div className="text-center">
                <Button className="small-btn" label="REFILL" onClick={() => {setIsWalletRefillVisible(true); setSelectedBranch(row)}} permissions={[141]} />
            </div> 
        )
    }

    const getResetBody = (row)=>{
        return(
            <div className="text-center">
                <Button className="small-btn" label="RESET" disabled></Button>
            </div> 
        )
    }

    const getWalletAmountBody = (row) =>{
        return(
            numberConversion(parseFloat(row.walletAmount), numberLocale)
        )
    }

    const getSpentAmountBody = (row) => {
        const relatedSpentAmountObj = spentAmounts.find(obj => obj.pmBranchId === row.branchId)

        if(relatedSpentAmountObj){
            return numberConversion(parseFloat(relatedSpentAmountObj.spentAmount), numberLocale)
        } else {
            return 0
        }
    }

    const getPayableAmountBody = (row) => {
        const relatedPayableAmounts = payableAmounts.filter(obj => obj.pmBranchId === row.branchId)

        let totalPayableAmount = 0
        relatedPayableAmounts.map(eachPayableObj => {
            if(["NON_CREDIT_PAYMENT", "CREDIT_PAYMENT", "CHEQUE_PAYMENT"].includes(eachPayableObj.paymentEligibleType)){
                totalPayableAmount += eachPayableObj.sum
            }
        })
        totalPayableAmount = round(totalPayableAmount, 2)

        const non_credit_payment = relatedPayableAmounts.find(eachAmount => eachAmount.paymentEligibleType === "NON_CREDIT_PAYMENT")
        const credit_payment = relatedPayableAmounts.find(eachAmount => eachAmount.paymentEligibleType === "CREDIT_PAYMENT")
        const cheque_payment = relatedPayableAmounts.find(eachAmount => eachAmount.paymentEligibleType === "CHEQUE_PAYMENT")

        if(totalPayableAmount){
            return (
                <>
                    <p className={`custom-tooltip-${row.branchId}`} style={{margin: 0, cursor: 'help'}} >{numberConversion(parseFloat(totalPayableAmount), numberLocale)}</p>
                    <Tooltip target={`.custom-tooltip-${row.branchId}`} position="top" autoHide>
                        <>
                            <p className="m-0 mb-1">Non Credit Amount : {non_credit_payment?.sum}</p>
                            <p className="m-0 mb-1">Credit Amount : {credit_payment?.sum}</p>
                            <p className="m-0">Cheque Amount : {cheque_payment?.sum}</p>
                        </>
                    </Tooltip>
                </>
            )
        } else {
            return 0
        }
    }

    const actionMenuItems = [
        {
            label: 'Create Internal Transfer',
            command: () => {
                setIsVisibleInternalTransferInv(true)
            },
            permissions: [36]
        }
    ]

    const tableColumns = [
        {
            header: 'Branch', field: 'companyBranch.branchName', style:{ textAlign: "center" }
        },
        {
            header: 'Wallet', field: 'walletAmount', body: getWalletAmountBody, style:{ textAlign: "center" }
        },
        /*{
            header: 'Spent Budget', field: '', body: getSpentAmountBody, style:{ textAlign: "center" }
        },*/
        {
            header : 'Payable Amount', field : 'payableAmount', body: getPayableAmountBody, style:{ textAlign: "center" }
        },
        {
            header: 'Refill Wallet', field: 'refillWallet', body : getRefillWalletBody, style:{ textAlign: "center" }
        },
        {
            header: 'Reset', field: 'reset', body: getResetBody, style:{ textAlign: "center" }
        }
    ]

    const handleRefillWallet = async () => {
        if(parseFloat(amount) <= 0){
            return dispatch(raiseToast({severity:'error', detail: "Enter Amount", life: 3000}))
        }
        setIsLoading(true)

        const data = {
            amount: parseFloat(amount),
            pmBranchId: selectedBranch.branchId
        }
        if(window.confirm("Are you sure you want to refill budget")){
            const response = await refillWallet(data)
            if (response.failure){
                dispatch(raiseToast({severity:'error', summary: 'Error', detail: "Refill failed", life: 3000}))
            }else {
                fetchPMBranches()
                setIsWalletRefillVisible(false)
                setAmount(0)
                dispatch(raiseToast({severity:'success', summary: 'Success', detail: "Amount refilled Successfully", life: 3000}))
            }
            console.log("refillWallet - response", response)
        }
        
        setIsLoading(false)
    }

    const handleWalletAmountChange = async (event) => {
        setAmount(event.target.value)
    }

    return (
        <div>
            <div className="vp-credit-non-credit-layout flex flex-column">
                <div className="flex flex-column md:flex-row md:justify-content-between">
                    <h4 className="mx-2 my-1 md:m-2">CASH FLOW TRACKER</h4>
                    <Menu model={actionMenuItems} popup menuRef={actionMenu} />
                    <div className="flex justify-content-end mb-2">
                        <Button className="h-2rem p-2 action-btn hover:surface-400 hover:text-700 surface-300" label="Action" onClick={(e) => actionMenu.current.toggle(e)} />
                    </div>
                </div>
                <div className='flex flex-row'>
                    <div className="cash-flow-tracker-table" style={{ order: "1", width: "100%" }}>
                        <div className='p-card mb-0'>
                            <div className="flex-grow-1 petty-cash-table" >
                                <Table
                                    tableColumns={tableColumns}
                                    data={pmBranches}
                                    scrollable={"true"}
                                    //loading={isTableLoading}
                                    scrollHeight={"620px"}
                                />
                            </div>
                        </div>
                    </div>

                    <Dialog header="REFILL WALLET" visible={isWalletRefillVisible} style={{ width: '45vw', height: '25vh' }} onHide={() => {setIsWalletRefillVisible(false)}}>
                        <div className="ml-2 mr-2 mt-0 pt-0">
                            <div>
                                <div className="flex justify-content-between mt-3">
                                    <div className="flex flex-column col-12 mb-2 lg:col-4 lg:mb-0">
                                        <TextInputField name="Branch" labelText="Branch" value={selectedBranch?.companyBranch?.branchName} disabled/>
                                    </div>
                                    <div className="flex flex-column col-12 mb-2 lg:col-4 lg:mb-0">
                                        <TextInputField name="amount" labelText="Amount" value={amount} onChange={handleWalletAmountChange} keyfilter="num" />
                                    </div>
                                    <div className="flex flex-column col-12 mb-2 lg:col-4 lg:mb-0 mt-3">
                                        <Button className="" label="REFILL WALLET" onClick={() => {handleRefillWallet()}} ></Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Dialog>

                    <Dialog header="CREATE FINANCE INTERNAL TRANSFER"  className="create-internal-transfer-dialog" visible={isVisibleInternalTransferInv} style={{ minHeight: "70vh" }} onHide={() => setIsVisibleInternalTransferInv(false)}>
                        <CreateInternalTransferInvoice procmartStates={procmartStates} pmBillAddresses={pmBillAddresses} warehouseShipAddresses={warehouseShipAddresses} setIsLoading={setIsLoading} setIsVisibleInternalTransferInv={setIsVisibleInternalTransferInv} />
                    </Dialog>

                    <Loading visible={isLoading} />
                </div>
            </div>
        </div>
    )
}

export default CashFlowTracker;